import React from "react";
import { useTranslation } from "react-i18next";
import { TrendingUp } from "lucide-react";
import { realizedOutcome } from "@/lib/decisionGraphLegend";

// Predicted-vs-realized savings. Predicted is a MODELED projection; realized is
// 'measured' ONLY when a real measured Evidence record exists for this run
// (R3 join-logging) — otherwise it renders "Unavailable", never a placeholder.
function basisClass(basis) {
  if (basis === "measured") return "text-[var(--qn-success)]";
  if (basis === "modeled") return "text-[var(--qn-warning)]";
  return "text-[var(--qn-foreground-subtle)]";
}

export default function RealizedOutcomePanel({ summary, evidence }) {
  const { t } = useTranslation();
  const { rows, hasMeasured } = realizedOutcome(summary, evidence);
  const fmt = (row) => {
    if (row.basis === "unavailable" || row.value == null) return t("decisionGraph.realized.basis.unavailable");
    const v = Number(row.value);
    const sign = row.key === "delta" && v > 0 ? "+" : "";
    return `${sign}${v.toFixed(1)}%`;
  };
  return (
    <div data-testid="realized-outcome-panel">
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-[var(--qn-foreground-subtle)] font-semibold mb-2">
        <TrendingUp className="w-3.5 h-3.5" />{t("decisionGraph.realized.title")}
      </div>
      <div className="grid grid-cols-1 gap-2">
        {rows.map((row) => (
          <div key={row.key} data-testid={`realized-${row.key}`} data-basis={row.basis}
            className="rounded-lg border border-[var(--qn-border)] bg-[var(--qn-surface)] px-2.5 py-2">
            <div className="flex items-center justify-between">
              <span className="text-[10px] text-[var(--qn-foreground-subtle)]">{t(`decisionGraph.realized.${row.key}`)}</span>
              <span data-testid={`realized-${row.key}-basis`} className={`text-[9px] uppercase tracking-wide font-semibold ${basisClass(row.basis)}`}>
                {t(`decisionGraph.realized.basis.${row.basis}`)}
              </span>
            </div>
            <div className={`text-xs font-semibold ${row.basis === "unavailable" ? "text-[var(--qn-foreground-subtle)]" : "text-[var(--qn-foreground)]"}`}>
              {fmt(row)}
            </div>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-[var(--qn-foreground-subtle)] mt-2" data-testid="realized-note">
        {hasMeasured ? t("decisionGraph.realized.note") : t("decisionGraph.realized.pending")}
      </p>
    </div>
  );
}
